import { scrollLock } from './util';

const Matrix = (() => {
    /**
     * Initializes the event listeners for the pricing matrix component
     */
    const initializeListeners = () => {
        $(document)
            .on('click', '.js-matrix-row', e => {
                const $target = $(e.currentTarget);
                const id = $target.data('row-id');
                const $modal = $(`.js-matrix-modal[data-modal-id="${id}"]`);
                const ttContent = $modal.html();

                // create modal
                $('.page').append(`<div class="tt-modal from-side"><span class="modal-close js-tt-matrix-modal-close"></span><div class="tooltip-content"></div></div><div class="tt-overlay js-tt-matrix-overlay"></div>`);
                $('.tt-modal .tooltip-content').replaceWith(ttContent);
                // add small timeout for animation purposes
                setTimeout(() => {
                    $('.tt-modal').addClass('show');
                    $('body').addClass('tt-popup-overlay');
                    scrollLock('on');
                }, 10);
            })
            .on('click', e => {
                const $target = $(e.target);

                if ($target.is('.js-tt-matrix-modal-close') || $target.is('.js-tt-matrix-overlay')) {
                    $('body').find('.tt-modal').removeClass('show');
                    $('body').removeClass('tt-popup-overlay');
                    $('.page').find('.tt-modal, .js-tt-matrix-overlay').remove('.tt-modal, .js-tt-matrix-overlay');
                    scrollLock('off');
                }
            });
    };

    /**
     * Calculates the padding bottom of the table
     */
    const calculateStickyPadding = () => {
        const matrixTable = $('.matrix__table');
        const matrixRow = $('.matrix__row');
        const matrixRowLastHeight = matrixRow.last().height();
        matrixTable.css('padding-bottom', matrixRowLastHeight);
    };

    return {
        init() {
            initializeListeners();
            calculateStickyPadding();
        },

        resize() {
            calculateStickyPadding();
        },
    };
})();

export default (() => {
    $(Matrix.init);
})();
